/* eslint-disable max-classes-per-file */
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { AreaSelectionMarknadsomrade, IAreaSelectionOmrade } from "~app/common/models/areaSelector";
import { Avverkningsformer, Svar } from "~app/common/models/constants";
import { DistriktDTO } from "~app/common/models/distrikt/DistriktDTO";
import { KommunDTO } from "~app/common/models/distrikt/KommunDTO";
import { LanDTO } from "~app/common/models/distrikt/LanDTO";
import { BefraktareDto } from "~app/common/models/styrtabeller/BefraktareDto";
import { MottagningsplatsDTO } from "~app/common/models/styrtabeller/MottagningsplatsDTO";
import { RedovisningshanvisningDto } from "~app/common/models/styrtabeller/RedovisningshanvisningDto";
import { StyrtabellLanKommunDistriktDTO } from "~app/common/models/styrtabeller/StyrtabellLanKommunDistriktDTO";
import { StyrtabellMatningsinformationDto } from "~app/common/models/styrtabeller/StyrtabellMatningsinformationDto";
import { StyrtabellRedovisningshanvisningDto } from "~app/common/models/styrtabeller/StyrtabellRedovisningshanvisningDto";
import { StyrtabellVerksamhetsomradeDTO } from "~app/common/models/styrtabeller/StyrtabellVerksamhetsomradeDTO";
import { GuidUtils } from "~app/common/utils/guid-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";

export interface IRegelverkViol3SearchModel {
    mottagningsplats?: string;
    mottagare?: string;
    inmatningshandelssortiment?: string;
    selectedMoRoPo?: any[];
}

export interface IVerksamhetsomraden extends StyrtabellVerksamhetsomradeDTO {
    label?: string;
    type?: string;
}

export class StyrtabellRedovisningshanvisningHandelssortimentDto {
    guid: string;
    inmatningshandelssortiment: string;
    redovisningshanvisning: RedovisningshanvisningDto;
}

export class StyrtabellRedovisningshanvisningIdHandelssortimentDto {
    guid: string;
    ersatt: boolean;
    inmattHandelssortiment: string;
    redovisningshanvisningId?: number;
}

export class ExtraHsRhViewModel {
    guid: string;
    inmatningshandelssortiment: string;
    redovisningshanvisning: RedovisningshanvisningDto;
    constructor(hs: string, rh: RedovisningshanvisningDto, guid?: string) {
        this.guid = guid ?? GuidUtils.newGuid();
        this.inmatningshandelssortiment = hs;
        this.redovisningshanvisning = rh;
    }
}

export class StyrtabellBaseViewModel {

    styrtabellVerksamhetsomraden: StyrtabellVerksamhetsomradeDTO[] = [];
    treeselectorVerksamhetsomradeSelectItems: SelectionItem[] = [];
    treeselectorVerksamhetsomradeSelectValue: string[] = [];
    treeselectorLkdSelectItems: SelectionItem[] = [];
    styrtabellLkd: StyrtabellLanKommunDistriktDTO[] = [];

    initSelectedVerksamhetsomraden(verksamhetsomraden: AreaSelectionMarknadsomrade[]): void {
        verksamhetsomraden.forEach(mo => {
            const selectionItem = this.getSelectionItem(mo);

            mo.children.forEach(ro => {
                this.appendResultatomraden(selectionItem, ro);
            });

            const childrenSelected = selectionItem.children.every(x => x.selected);
            const childrenPartialSelected = !childrenSelected && selectionItem.children.some(x => x.selected || x.partialSelected);
            const selectedInStyrtabell = this.styrtabellVerksamhetsomraden?.some(x => x.marknadsomrade === mo.guid);

            selectionItem.selected = !childrenPartialSelected && (childrenPartialSelected || selectedInStyrtabell);
            selectionItem.partialSelected = childrenPartialSelected;
        });
    }
    initSelectedLkd(lkd: LanDTO[]) {
        lkd.forEach(lan => {
            const selectionItem = this.getLanSelectionItem(lan);
            lan.children.forEach(kommun => {
                this.appendKommun(selectionItem, kommun);
            });

            const childrenSelected = selectionItem.children.every(x => x.selected);
            const childrenPartialSelected = !childrenSelected && selectionItem.children.some(x => x.selected || x.partialSelected);
            const selectedInStyrtabell = this.styrtabellLkd?.some(x => x.lanKod === lan.lanKod);

            selectionItem.selected = !childrenPartialSelected && (childrenPartialSelected || selectedInStyrtabell);
            selectionItem.partialSelected = childrenPartialSelected;
        });
    }

    private getLanSelectionItem(item: LanDTO) {
        let selectionItem = this.treeselectorLkdSelectItems.find(x => x.value === item.lanKod);
        if(selectionItem) {
            return selectionItem;
        }
        selectionItem = new SelectionItem();
        selectionItem.value = item.lanKod;
        selectionItem.text = `${item.lanKod} ${item.namn}`;
        this.treeselectorLkdSelectItems.push(selectionItem);
        return selectionItem;
    }

    private appendKommun(selectionitem: SelectionItem, kommun: KommunDTO): void {

        if(!selectionitem.children) {
            selectionitem.children = [];
        }

        const newSelectionitem = new SelectionItem();
        newSelectionitem.value = kommun.kommunKod;
        newSelectionitem.text = `${kommun.kommunKod} ${kommun.namn}`;

        kommun.children.forEach(distrikt => {
            this.appendDistrikt(newSelectionitem, distrikt);
        });

        const childrenSelected = newSelectionitem.children.every(x => x.selected);
        const childrenPartialSelected = !childrenSelected && newSelectionitem.children.some(x => x.selected);
        const selectedInStyrtabell = this.styrtabellLkd?.some(x => x.kommunKod === kommun.kommunKod);

        newSelectionitem.selected = !childrenPartialSelected && (childrenPartialSelected || selectedInStyrtabell);
        newSelectionitem.partialSelected = childrenPartialSelected;

        selectionitem.children.push(newSelectionitem);
    }

    private appendDistrikt(selectionitem: SelectionItem, distrikt: DistriktDTO) {
        if(!selectionitem.children) {
            selectionitem.children = [];
        }

        const newSelectionitem = new SelectionItem();
        newSelectionitem.value = distrikt.lkdKod;
        newSelectionitem.text = `${distrikt.lkdKod} ${distrikt.namn}`;
        newSelectionitem.selected = this.styrtabellLkd?.some(x => x.lkdKod === distrikt.lkdKod);
        selectionitem.children.push(newSelectionitem);
    }

    private getSelectionItem(item: AreaSelectionMarknadsomrade): SelectionItem {
        let selectionItem = this.treeselectorVerksamhetsomradeSelectItems.find(x => x.value === item.guid);
        if(selectionItem) {
            return selectionItem;
        }
        selectionItem = new SelectionItem();
        selectionItem.value = item.guid;
        selectionItem.text = item.namn;
        this.treeselectorVerksamhetsomradeSelectItems.push(selectionItem);
        return selectionItem;
    }

    private appendResultatomraden(selectionitem: SelectionItem, resultatomrade: AreaSelectionMarknadsomrade): void {

        if(!selectionitem.children) {
            selectionitem.children = [];
        }

        const newSelectionitem = new SelectionItem();
        newSelectionitem.value = resultatomrade.guid;
        newSelectionitem.text = resultatomrade.namn;

        resultatomrade.children.forEach(po => {
            this.appendProduktionsOmrade(newSelectionitem, po);
        });

        const childrenSelected = newSelectionitem.children.every(x => x.selected);
        const childrenPartialSelected = !childrenSelected && newSelectionitem.children.some(x => x.selected);
        const selectedInStyrtabell = this.styrtabellVerksamhetsomraden?.some(x => x.resultatomrade === resultatomrade.guid);

        newSelectionitem.selected = !childrenPartialSelected && (childrenPartialSelected || selectedInStyrtabell);
        newSelectionitem.partialSelected = childrenPartialSelected;

        selectionitem.children.push(newSelectionitem);
    }

    private appendProduktionsOmrade(selectionitem: SelectionItem, produktionsomrade: IAreaSelectionOmrade) {
        if(!selectionitem.children) {
            selectionitem.children = [];
        }

        const newSelectionitem = new SelectionItem();
        newSelectionitem.value = produktionsomrade.guid;
        newSelectionitem.text = produktionsomrade.namn;
        newSelectionitem.selected = this.styrtabellVerksamhetsomraden?.some(x => x.produktionsomrade === produktionsomrade.guid);
        selectionitem.children.push(newSelectionitem);
    }
}

export class StyrtabellRedovisningshanvisningViewModel extends StyrtabellBaseViewModel {
    id: number;
    guid: string;
    mottagningsplats: MottagningsplatsDTO;
    mottagningsplatsId?: number;
    inmatningshandelssortiment: string;
    ersattningsrad: boolean;
    befraktare: BefraktareDto;
    anskaffningsform: string[];
    affarsform: string[];
    avverkningsform: any;
    namn: string;
    transportslag: string;
    kontraktstyp: string;
    styrtabellRedovisningshanvisningar: StyrtabellRedovisningshanvisningHandelssortimentDto[];
    redovisningshanvisning: RedovisningshanvisningDto;
    styrtabellVerksamhetsomraden: StyrtabellVerksamhetsomradeDTO[] = [];
    treeselectorVerksamhetsomradeSelectItems: SelectionItem[] = [];
    treeselectorVerksamhetsomradeSelectValue: string[] = [];
    treeselectorLkdSelectItems: SelectionItem[] = [];

    constructor(private readonly model: StyrtabellRedovisningshanvisningDto,  verksamhetsomraden: AreaSelectionMarknadsomrade[], lkd: LanDTO[]) {
        super();
        this.id = model.id;
        this.guid = model.guid;
        this.mottagningsplats = model.mottagningsplats;
        this.mottagningsplatsId = model.mottagningsplats?.id;
        this.inmatningshandelssortiment = model.inmatningshandelssortiment;
        this.befraktare = model.befraktare;
        this.affarsform = model.affarsform;
        this.ersattningsrad = model.ersattningsrad;
        this.avverkningsform =  Avverkningsformer.Alla.find(x => x.kod === model.avverkningsform) ;
        this.anskaffningsform = model.anskaffningsform;
        this.namn = model.namn;
        this.transportslag = model.transportslag;
        this.kontraktstyp = model.kontraktstyp;
        this.redovisningshanvisning = model.styrtabellRedovisningshanvisningar?.find(x => ObjectUtils.isNullOrUndefined(x.inmatningshandelssortiment)).redovisningshanvisning;
        this.styrtabellVerksamhetsomraden = model.verksamhetsomraden;
        this.initSelectedVerksamhetsomraden(verksamhetsomraden);
        this.styrtabellLkd = model.lanKommunDistrikt;
        this.initSelectedLkd(lkd);
        this.styrtabellRedovisningshanvisningar = model.styrtabellRedovisningshanvisningar?.filter(x => ObjectUtils.hasValue(x.inmatningshandelssortiment)) ?? [];
    }
}
export class StyrtabellMatinformationViewModel extends StyrtabellBaseViewModel {
    id: number;
    guid: string;
    inmatningshandelssortiment: string;
    transportslag: string;
    befraktare: BefraktareDto;
    anskaffningsform: string[];
    affarsform: string[];
    mattslag: string;
    andraMattslag?: boolean;
    set andraMattslagString(value: string) {
        this._andraMattslagString = value;
        this.andraMattslag = this.getNullableBoolFromString(value);
    }
    get andraMattslagString() {
        return this._andraMattslagString;
    }
    kvalitetsklassningKravs?: boolean;
    set kvalitetsklassningKravsString(value: string) {
        this._kvalitetsklassningKravsString = value;
        this.kvalitetsklassningKravs = this.getNullableBoolFromString(value);
    }
    get kvalitetsklassningKravsString() {
        return this._kvalitetsklassningKravsString;
    }
    stockmatningKravs?: boolean;
    set stockmatningString(value: string) {
        this._stockmatningString = value;
        this.stockmatningKravs = this.getNullableBoolFromString(value);
    }
    get stockmatningString() {
        return this._stockmatningString;
    }
    prioriteradMatmetod: string;
    private _andraMattslagString: string;
    private _kvalitetsklassningKravsString: string;
    private _stockmatningString: string;

    constructor(private readonly model: StyrtabellMatningsinformationDto,  verksamhetsomraden: AreaSelectionMarknadsomrade[], lkd: LanDTO[]) {
        super();
        this.id = model.id;
        this.guid = model.guid;
        this.inmatningshandelssortiment = model.inmatningshandelssortiment;
        this.transportslag = model.transportslag;
        this.befraktare = model.befraktare;
        this.affarsform = model.affarsform;
        this.anskaffningsform = model.anskaffningsform;
        this.styrtabellVerksamhetsomraden = model.verksamhetsomraden;
        this.initSelectedVerksamhetsomraden(verksamhetsomraden);
        this.mattslag = model.mattslag;
        this.andraMattslag = model.andraMattslag;
        this.andraMattslagString = this.getStringFromNullableBool(model.andraMattslag);
        this.kvalitetsklassningKravs = model.kvalitetsklassningKravs;
        this.kvalitetsklassningKravsString = this.getStringFromNullableBool(model.kvalitetsklassningKravs);
        this.stockmatningKravs = model.stockmatningKravs;
        this.stockmatningString = this.getStringFromNullableBool(model.stockmatningKravs);
        this.prioriteradMatmetod = model.prioriteradMatmetod;
    }
    private getNullableBoolFromString(value: string): boolean {
        if (value === Svar.tomt || value === undefined) {
            return undefined;
        } else {
            return value === Svar.ja ? true : false;
        }
    }

    private getStringFromNullableBool(value: boolean | undefined | null): string {
        if (!ObjectUtils.hasValue(value)) {
            return Svar.tomt;
        }
        return value === true ? Svar.ja : Svar.nej;
    }
}
